import { useState, useEffect, useContext } from "react";
import ScholarDataService from "../services/ScholarService";
import Scholar from "./Scholar";
import { Context } from "../Context/GlobalState";

import { makeStyles } from '@material-ui/core/styles';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

export default function Scholars(props) {
  const classes = useStyles();
  const [team, setTeam] = useState('');
  const [scholars, setScholars] = useState([]);
  const [topMmr, setTopMmr] = useState([]);
  
  const handleChange = (event) => {
    setTeam(event.target.value);
  };

  const onDataChange = (items) => {
  let scholars = [];
    
    items.docs.forEach((item) => {
    // .where("team","==",user.team)
      // console.log(item.data() )
      let id = item.id;
      let data = item.data();  
      // if(data.team == user.team && data.team == team){
      if(user.team !== 'useradmin'){
        setTeam(user.team);
      }
      if(data.team == team){
        scholars.push({
          id: id,
          iskoNumber: data.iskoNumber,
          nickname: data.nickname,
          ethereumAddress: data.ethereumAddress,
          totalSlp: 0,
          claimable: 0,
          lastClaimed: "",
          claimableOn: ""
        });  
      }      

    });

    setScholars(scholars);
  };
  const { user } = useContext(
    Context
  );

  function handleScholar(currentScholar) {
      props.sendToHome(currentScholar);
  }

  useEffect(() => {
    const added = ScholarDataService.getAll()
    .orderBy('timestamp')
    .onSnapshot(onDataChange);
    return () => added();
  }, [team]);

  return (
    <div className="scholars">
      {user.team == 'useradmin' ? (
        <FormControl className={classes.formControl}>
        <InputLabel id="demo-simple-select-label">Team</InputLabel>
        <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={team}
        onChange={handleChange}
        >
        <MenuItem value='xencodes'>XenCodes</MenuItem>
        <MenuItem value='cls'>CLS</MenuItem>
        <MenuItem value='jtc'>JTC</MenuItem>
        </Select>
      </FormControl>
      ) : (
        <div></div>
      )}
      
      <table className="table">
        <thead>
          <tr>
            <th>Nickname</th>
            <th>MMR</th>
            <th>Daily AVG</th>
            <th>Claimable</th>
            <th>Total SLP</th>
            <th>Next Claim</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
            { scholars.length > 0 ? (
              scholars.map((scholar, index) => (
                <Scholar scholar={scholar} topMmr={topMmr} sendToScholars={handleScholar} key={scholar.id} />
              ))          
            ) : (
              <td colSpan="2">No Scholar(s)</td>
            )}  
        </tbody>        
    </table>  
    </div>
  );
}
